import React from 'react';
import ModalContainer from '../../../../uiToolkit/ModalContainer';
import {ReactComponent as CopyIcon} from '../../../../assets/images/copyIc.svg';
import {toast} from 'react-toastify';
import {aiAssistantText} from '../aiAssistantText';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';

interface Props {
  shareUrl: string;
  onClose: () => void;
}

const ShareAssistantUrlModal = ({shareUrl, onClose}: Props) => {
  const onCopy = () => {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => {
        toast.success(aiAssistantText.shareUrlCopied, toastConfig);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };
  return (
    <ModalContainer onClose={onClose} className="ShareAssistantModalContent">
      <div className="ShareAssistantUrlModal">
        <div className="ShareUrlModalHeader">
          {aiAssistantText.shareUrlTitle}
        </div>
        <div className="ShareUrlModalSubtitle">
          <p>{aiAssistantText.shareUrlSubtitle1}</p>
          <p>{aiAssistantText.shareUrlSubtitle2}</p>
        </div>
        <div className="ShareUrlRow">
          <div className="ShareUrl">{shareUrl}</div>
        </div>
        <button className="ShareUrlCopyButton" onClick={onCopy}>
          <CopyIcon title={aiAssistantText.copy} className="CopyIcon" />
          {aiAssistantText.copy}
        </button>
      </div>
    </ModalContainer>
  );
};

export default ShareAssistantUrlModal;
